import ctl from '@netlify/classnames-template-literals';

const pageLinkDisabledStyles = ctl(`
  text-bright-gray
  pointer-events-none
  border-white
`);

const pageLinkActiveStyles = ctl(`
  bg-crayola
  border-crayola
  hover:bg-crayola
  text-ghost-white
`);

const navStyle = ctl(`
  text-center
  mt-5
`);

const basicPageLinkStyles = ctl(`
  bg-white
  hover:bg-bright-gray
  text-waterspout
  border-anti-flash-white 
`);

const pageLinkStyles = ctl(`
  inline-flex
  text-sm
  font-normal
  border-r-[1px]
  select-none
  cursor-pointer
  first:rounded-tl-[5px]
  first:rounded-bl-[5px]
  last:rounded-tr-[5px]
  last:rounded-br-[5px]
  last:border-0
  focus:bg-bright-gray
  offset-base
`);

export { navStyle, pageLinkStyles, pageLinkDisabledStyles, pageLinkActiveStyles, basicPageLinkStyles };
